import React from 'react';
import { Lock, Gift, Mail, Clock, ShieldCheck, CreditCard, Folder, Briefcase, FileText } from 'lucide-react';
const items = [{
  icon: Lock,
  text: 'Pago 100% seguro con MercadoPago'
}, {
  icon: Gift,
  text: 'OFF por tiempo limitado'
}, {
  icon: FileText,
  text: 'Acceso inmediato por mail'
}, {
  icon: Clock,
  text: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheck,
  text: 'Garantía 7 días'
}, {
  icon: Briefcase,
  text: 'Tarjeta · Transferencia · Mercado Pago'
}];
export function TrustMarquee() {
  // Duplicate the list to create a seamless loop
  const loop = [...items, ...items];
  return <div className="bg-petroleum border-b border-white/5 overflow-hidden relative" data-id="element-747">
      {/* Decorative Tab Strip */}
      <div className="absolute top-0 left-0 w-full flex gap-4 px-4 opacity-20" data-id="element-748">
        <div className="w-16 h-1 bg-white/20 rounded-b-sm" data-id="element-749"></div>
        <div className="w-24 h-1 bg-white/20 rounded-b-sm" data-id="element-750"></div>
        <div className="w-12 h-1 bg-white/20 rounded-b-sm" data-id="element-751"></div>
      </div>

      <div className="relative" data-id="element-752">
        <div className="flex w-max animate-marquee gap-6 py-3 whitespace-nowrap" data-id="element-753">
          {loop.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} className="flex items-center gap-2 text-xs md:text-sm text-textsecondary font-mono uppercase tracking-wider px-3 py-1 bg-graphite/40 border border-white/5 rounded-md" data-id="element-754">
                <Icon className="w-3.5 h-3.5 text-gold flex-shrink-0" data-id="element-755" />
                <span data-id="element-756">{item.text}</span>
              </div>;
        })}
        </div>
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-petroleum to-transparent" data-id="element-757" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-petroleum to-transparent" data-id="element-758" />
      </div>
    </div>;
}